import { render, staticRenderFns } from "./SalonsAnalytics.vue?vue&type=template&id=6d347b24&scoped=true"
import script from "./SalonsAnalytics.vue?vue&type=script&lang=js"
export * from "./SalonsAnalytics.vue?vue&type=script&lang=js"
import style0 from "./SalonsAnalytics.vue?vue&type=style&index=0&id=6d347b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d347b24",
  null
  
)

export default component.exports